module.exports = __webpack_public_path__ + "img/cg.1bdb6a1b.svg";